import React, { useState } from 'react';
import { Heart, Star, Send } from 'lucide-react';
type Comment = {
  handle: string;
  rating: number;
  text: string;
  likes: number;
  timeAgo: string;
  liked?: boolean;
};
const COMMENT_POOL: Comment[] = [{
  handle: '@marco_trattoriabologna',
  rating: 5,
  text: 'Finalmente qualcosa di concreto. Ho applicato il sistema FIFO la prima settimana e ho già recuperato 240€ di sprechi. Vale ogni centesimo.',
  likes: 47,
  timeAgo: '2 ore fa'
}, {
  handle: '@claudia_pizzeria_napoli',
  rating: 5,
  text: "Ero scettica all'inizio. In due settimane ho ridotto i costi del 18% senza cambiare nulla del menù. Solo applicando le checklist.",
  likes: 32,
  timeAgo: '5 ore fa'
}, {
  handle: '@antonio_ristomilano',
  rating: 5,
  text: 'La parte sui margini di contribuzione mi ha aperto gli occhi. Avevo 4 piatti in perdita e non lo sapevo. Soldi buttati per anni.',
  likes: 28,
  timeAgo: '8 ore fa'
}, {
  handle: '@stefano_b_roma',
  rating: 4,
  text: "Tanto materiale, all'inizio sembra troppo. Ma una volta organizzato è oro puro. Le checklist cambio turno hanno salvato il mio locale.",
  likes: 19,
  timeAgo: '12 ore fa'
}, {
  handle: '@giovanna_firenze',
  rating: 5,
  text: 'Il protocollo ispezioni vale da solo il prezzo. Ispettore arrivato la settimana scorsa, tutto in regola al primo controllo.',
  likes: 24,
  timeAgo: '1 giorno fa'
}, {
  handle: '@roberto_bartorino',
  rating: 5,
  text: 'Da 15 anni nel settore. Pensavo di sapere tutto. Ho scoperto cose nuove dal primo capitolo. Consigliatissimo.',
  likes: 56,
  timeAgo: '1 giorno fa'
}, {
  handle: '@sofia_pasticceria',
  rating: 5,
  text: 'Le tecniche di upselling le ho fatte provare ai miei camerieri. +15% sullo scontrino medio in 10 giorni. Numeri reali.',
  likes: 41,
  timeAgo: '1 giorno fa'
}, {
  handle: '@luca_takeaway_genova',
  rating: 4,
  text: 'Niente fronzoli. Solo cose che funzionano. Il piano formazione lo sto usando con i nuovi assunti, mi fa risparmiare ore.',
  likes: 13,
  timeAgo: '1 giorno fa'
}, {
  handle: '@francesca_trattoria',
  rating: 5,
  text: 'Comprato di sera, scaricato subito, applicato il giorno dopo. Nessun software complicato, solo PDF chiari. Perfetto.',
  likes: 38,
  timeAgo: '1 giorno fa'
}, {
  handle: '@davide_ristopadova',
  rating: 5,
  text: 'Avevo sempre rimandato di sistemare la gestione. A 19,90€ non ho avuto scuse. Ora il locale gira da solo anche quando non ci sono.',
  likes: 67,
  timeAgo: '2 giorni fa'
}, {
  handle: '@elena_pizza_torino',
  rating: 5,
  text: "Mio marito è il cuoco e ha sempre fatto resistenza ai cambiamenti. Dopo aver letto il tomo sui costi ha cambiato idea in un'ora.",
  likes: 22,
  timeAgo: '2 giorni fa'
}, {
  handle: '@simone_brescia',
  rating: 4,
  text: 'Ottimo prodotto. Mi sarebbe piaciuto qualche video ma per il prezzo non posso lamentarmi. Tutto ben spiegato comunque.',
  likes: 9,
  timeAgo: '2 giorni fa'
}, {
  handle: '@valeria_bistrot',
  rating: 5,
  text: 'I bonus valgono più del prodotto principale secondo me. Il calcolatore costi piatto lo uso ogni volta che cambio il menù.',
  likes: 44,
  timeAgo: '2 giorni fa'
}, {
  handle: '@giorgio_osteria_pa',
  rating: 5,
  text: 'Sistemato il magazzino in 3 giorni seguendo il protocollo. Mai stato così ordinato in 8 anni di attività. Grazie davvero.',
  likes: 31,
  timeAgo: '2 giorni fa'
}, {
  handle: '@martina_caffeteria',
  rating: 5,
  text: 'Lo consiglio a tutti i colleghi. Investimento minimo, risultati enormi. Già recuperato 10x il prezzo in un mese.',
  likes: 52,
  timeAgo: '2 giorni fa'
}];
export function CommentsSection() {
  const [text, setText] = useState('');
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [showSuccess, setShowSuccess] = useState(false);
  const [visibleCount, setVisibleCount] = useState(5);
  const [likedMap, setLikedMap] = useState<Record<number, boolean>>({});
  const visibleComments = COMMENT_POOL.slice(0, visibleCount);
  const canLoadMore = visibleCount < COMMENT_POOL.length;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!text.trim() || rating === 0) return;
    setShowSuccess(true);
    setText('');
    setRating(0);
    setTimeout(() => setShowSuccess(false), 5000);
  };
  const toggleLike = (idx: number) => {
    setLikedMap(m => ({
      ...m,
      [idx]: !m[idx]
    }));
  };
  const loadMore = () => {
    setVisibleCount(c => Math.min(c + 5, COMMENT_POOL.length));
  };
  return <div className="mb-20 cv-auto" data-id="element-199">
      <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-3 uppercase tracking-tight" data-id="element-200">
        Commenti di chi ha già accesso
      </h2>
      <p className="text-center text-gray-400 mb-10 text-sm md:text-base" data-id="element-201">
        Oltre 1.200 titolari hanno già trasformato il loro locale
      </p>

      {/* Submission form */}
      <div className="max-w-2xl mx-auto glass-panel p-6 md:p-8 rounded-2xl border-gold-500/20 mb-10 relative overflow-hidden" data-id="element-202">
        <h3 className="text-lg font-bold text-white mb-4" data-id="element-203">
          Lascia la tua recensione per la community:
        </h3>
        <form onSubmit={handleSubmit} className="space-y-4" data-id="element-204">
          <textarea value={text} onChange={e => setText(e.target.value)} placeholder="Scrivi qui la tua esperienza con il Sistema di Gestione Gastronomica..." rows={4} className="w-full px-4 py-3 bg-black/40 border border-white/10 rounded-xl text-white placeholder-gray-500 focus:outline-none focus:border-gold-500/50 focus:ring-1 focus:ring-gold-500/30 resize-none transition-colors" data-id="element-205" />
          <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:justify-between" data-id="element-206">
            <div className="flex items-center gap-3" data-id="element-207">
              <span className="text-sm text-gray-400 font-medium" data-id="element-208">Valuta:</span>
              <div className="flex items-center gap-1" data-id="element-209">
                {[1, 2, 3, 4, 5].map(n => <button key={n} type="button" onClick={() => setRating(n)} onMouseEnter={() => setHoverRating(n)} onMouseLeave={() => setHoverRating(0)} className="p-0.5 focus:outline-none focus:ring-2 focus:ring-gold-500/40 rounded" aria-label={`${n} stelle`} data-id="element-210">
                    <Star className={`w-6 h-6 transition-colors ${n <= (hoverRating || rating) ? 'text-gold-400 fill-current' : 'text-gray-600'}`} data-id="element-211" />
                  </button>)}
              </div>
            </div>
            <button type="submit" disabled={!text.trim() || rating === 0} className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-gradient-to-b from-gold-400 to-gold-600 text-dark-900 font-bold uppercase tracking-wider text-sm transition-all duration-200 hover:from-gold-300 hover:to-gold-500 disabled:opacity-40 disabled:cursor-not-allowed shadow-lg shadow-gold-500/20" data-id="element-212">
              <Send className="w-4 h-4" data-id="element-213" />
              Pubblica
            </button>
          </div>
        </form>

        {showSuccess && <div role="status" className="mt-5 px-4 py-3 rounded-xl bg-emerald-500/10 border border-emerald-500/30 text-emerald-300 text-sm font-medium animate-in fade-in slide-in-from-top-2" data-id="element-214">
            ✓ Grazie! Il tuo commento sarà pubblicato a breve dopo la
            moderazione.
          </div>}
      </div>

      {/* Comments list */}
      <div className="max-w-2xl mx-auto space-y-4" data-id="element-215">
        {visibleComments.map((c, i) => {
        const isLiked = !!likedMap[i];
        const displayLikes = c.likes + (isLiked ? 1 : 0);
        return <div key={i} className="glass-panel p-5 md:p-6 rounded-2xl border-white/5" data-id="element-216">
              <div className="flex items-start justify-between gap-3 mb-2" data-id="element-217">
                <span className="font-bold text-gold-400 text-sm md:text-base break-all" data-id="element-218">
                  {c.handle}
                </span>
                <div className="flex items-center gap-0.5 shrink-0" data-id="element-219">
                  {[...Array(5)].map((_, j) => <Star key={j} className={`w-3.5 h-3.5 ${j < c.rating ? 'text-gold-400 fill-current' : 'text-gray-700'}`} data-id="element-220" />)}
                </div>
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed mb-3" data-id="element-221">
                {c.text}
              </p>
              <div className="flex items-center gap-4 text-xs text-gray-500" data-id="element-222">
                <button type="button" onClick={() => toggleLike(i)} className={`inline-flex items-center gap-1.5 transition-colors focus:outline-none ${isLiked ? 'text-rose-400' : 'hover:text-rose-400'}`} aria-label="Mi piace" data-id="element-223">
                  <Heart className={`w-4 h-4 ${isLiked ? 'fill-current' : ''}`} data-id="element-224" />
                  <span className="font-medium" data-id="element-225">{displayLikes} Likes</span>
                </button>
                <span data-id="element-226">{c.timeAgo}</span>
              </div>
            </div>;
      })}

        {canLoadMore && <div className="pt-2 flex justify-center" data-id="element-227">
            <button type="button" onClick={loadMore} className="px-6 py-3 rounded-xl border border-white/10 bg-white/[0.02] text-white text-sm font-semibold hover:bg-white/[0.05] hover:border-gold-500/30 transition-all" data-id="element-228">
              Carica altri 5 commenti
            </button>
          </div>}
      </div>
    </div>;
}